import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  has_prev: false,
  has_next: false,
  total_pages: 0,
  total_results: 0,
  error: "",
  data: [],
  page: 1,
}

const cartReportingSlice = createSlice({
  name: 'cartReportingSlice',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
      state.error = ''
    },

    setCartReportListing: (state, action) => {
      return {
        ...state, loading: false,
        has_next: action.payload.has_next,
        has_prev: action.payload.has_prev,
        total_pages: action.payload.total_pages,
        total_results: action.payload.total_results,
        page: action.payload.page,
        data: action.payload.data,
        error: ''
      };
    },

    getCartReportListing: (state, action) => {
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setPage:(state, action) => {
      state.page = action.payload;
    }
  }

})

export const {
  setLoading,
  setError,
  setCartReportListing,
  getCartReportListing,
  setPage
} = cartReportingSlice.actions;
export default cartReportingSlice.reducer;
